module.exports = __webpack_public_path__ + "img/get-directions.fb239758.svg";